import { Badge, Text } from '@mantine/core';
import { IconPlaneDeparture } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';

import classes from './Brand.module.css';

/** «✈ AirCourier [Админка]» logotype; a link when `to` is given. */
export function Brand({ to }: { to?: string }) {
  const { t } = useTranslation('nav');
  const content = (
    <>
      <span className={classes.mark}>
        <IconPlaneDeparture size={18} stroke={1.75} />
      </span>
      <Text component="span" fw={700} size="md">
        {t('brand')}
      </Text>
      <Badge variant="light" color="gray" size="sm">
        {t('brandSuffix')}
      </Badge>
    </>
  );
  return to ? (
    <Link to={to} className={classes.root}>
      {content}
    </Link>
  ) : (
    <span className={classes.root}>{content}</span>
  );
}
